<app-stages [stages]="stages" currentStage="Dane przejazdu"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <div class='row'>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"startDate" as controlName'>
          <label [for]='controlName'>
            Data od *
          </label>
          <app-date-picker [id]='controlName' [formControlName]='controlName'>
          </app-date-picker>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"endDate" as controlName'>
          <label [for]='controlName'>
            Data do *
          </label>
          <app-date-picker [id]='controlName' [formControlName]='controlName'>
          </app-date-picker>
          <app-validation-errors fieldLabel='Data od' secondFieldLabel='dacie do' [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    @if (form.vehicleForm; as vehicleForm) {
      <app-vehicle-form [form]="vehicleForm">
      </app-vehicle-form>
    }
    @if (application()?.applicationSubject === 'Kategorii II') {
      <app-alert [closable]="false" [withoutIcon]="true">
        <div class="mb-2"><strong>Uwaga!</strong></div>
        <p class="mb-2">Wniosek dotyczy wydania zezwolenia na przejazdy pojazdów nienormatywnych po drogach publicznych
          pojazdu nienormatywnego, którego:</p>
        <ol class="normal">
          <li class="mb-1">
            <dl>
              <dt>
                Długość nie przekracza:
              </dt>
              <dd>
                <ul class="ms-1">
                  <li>
                    15 m dla pojedynczego pojazdu
                  </li>
                  <li>
                    23,0 m dla zespołu pojazdu
                  </li>
                  <li>
                    <del>30,0 m dla zespołu pojazdu o skrętnych osiach</del>
                  </li>
                </ul>
              </dd>
            </dl>
          </li>
          <li class="mb-1">
            <dl>
              <dt>
                Szerokość nie przekracza:
              </dt>
              <dd>
                <ul class="ms-1">
                  <li>
                    3,2 m
                  </li>
                  <li>
                    <del>3,4 m</del>
                  </li>
                  <li>
                    <del>4 m</del>
                  </li>
                </ul>
              </dd>
            </dl>
          </li>
          <li class="mb-1">
            Wysokość nie przekracza 4,30 m
          </li>
          <li class="mb-1">
            Naciski osi nie są większe od dopuszczalnych
          </li>
          <li class="mb-1">
            Rzeczywista masa całkowita nie jest większa od dopuszczalnej
          </li>
          <li>
            <del>Rzeczywista masa całkowita nie przekracza 60 t</del>
          </li>
        </ol>

      </app-alert>
    }
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
